// extracted by mini-css-extract-plugin
export default {"disable":"Module_disable__2Zvn5"};